export default __webpack_public_path__ + "static/media/hostingSc.f7f9425f.png";